
// Define product data structure 
export interface Product {
  id: number;
  name: string;
  description: string;
  price: string;
  image: string;
  link: string;
}

// Define all products
export const products: Product[] = [
  {
    id: 9,
    name: "Hey Humans Natural Deodorant",
    description: "Contains naturally derived ingredients. Aluminum-free, vegan and cruelty-free natural deodorant with essential oils. Available in multiple scents with sustainable packaging.",
    price: "$12.99",
    image: "/lovable-uploads/e3ece06c-b176-4067-a58f-bb4f1c09d65a.png",
    link: "https://www.heyhumansusa.com/?dt_id=2391110"
  },
  {
    id: 1,
    name: "Grooming Lounge Greatest Pits Deodorant",
    description: "A natural deodorant that actually works. Free from aluminum, parabens, and harmful chemicals.",
    price: "$23.00",
    image: "/lovable-uploads/7553ea87-a17e-481c-b7fb-9548fb2ffd93.png",
    link: "https://murphyandmcneil.com/products/grooming-lounge-greatest-pits-deodorant?sca_ref=8468498.oO9QXbgAQO"
  },
  {
    id: 2,
    name: "Kinko Care Natural Deodorant",
    description: "100% natural and vegan deodorant that effectively neutralizes odor. Free from aluminum, alcohol, and baking soda.",
    price: "$18.00",
    image: "/lovable-uploads/a2ef7eb0-0c25-4d2e-885a-ecbd6e258b4a.png",
    link: "https://www.kinko.care/?ref=rlexraps"
  },
  {
    id: 3,
    name: "It Just Works Deodorant",
    description: "A natural deodorant that actually works. Free from aluminum, parabens, and harmful chemicals.",
    price: "$35.99",
    image: "/lovable-uploads/a38e4978-a37a-452c-a67e-140d9acc3d2e.png",
    link: "https://itjustworksdeodorant.com?sca_ref=8468108.vEEWUNzhD1"
  },
  {
    id: 4,
    name: "Breathe Naturals \"The Dude Pit Pack\"",
    description: "🥥 Try our Three Most Popular Scents for Guys: Bergamot Lime, Cedar Spice, and Cooling CocoMint! Premium aluminum-free natural deodorants with three specialized formulas for all-day freshness and protection.",
    price: "$19.99",
    image: "/lovable-uploads/dfd030d9-652d-4a06-95f1-a4eb346dddfc.png",
    link: "https://breathenaturals.com/r?id=7ncs5u"
  },
  {
    id: 5,
    name: "Breathe Naturals \"The Chick Pit Pack\"",
    description: "🌸 Includes our Three Most Popular Scents for Ladies: Grapefruit Lemon, Lavender Vanilla & Summer Seabreeze! Premium aluminum-free natural deodorants for all-day freshness and protection.",
    price: "$19.99",
    image: "/lovable-uploads/857f4c02-05d0-40a3-a419-3faf644767b1.png", 
    link: "https://breathenaturals.com/r?id=slae8t"
  },
  {
    id: 6,
    name: "Skillano Beauty Laser Hair Removal",
    description: "Professional-grade at-home laser hair removal device. Safe for all skin types and perfect for underarm treatment.",
    price: "$179.99",
    image: "/lovable-uploads/c496d496-c3cc-4846-b006-d74eeb924c08.png",
    link: "https://skillanobeauty.com"
  },
  {
    id: 7,
    name: "Travel Safety Razor",
    description: "Premium travel safety razor with leather case by Parker. Perfect for a close, irritation-free shave.",
    price: "$29.99",
    image: "/lovable-uploads/8d7b1b4e-2a3c-48a9-bd1b-e8f1f403758c.png",
    link: "https://murphyandmcneil.com/products/travel-safety-razor-with-leather-case-a1r-by-parker?sca_ref=8468498.oO9QXbgAQO"
  },
  {
    id: 8,
    name: "Rockwell Double Edge Razor Blades",
    description: "High-quality, durable razor blades for a smooth, close shave without irritation or ingrown hairs.",
    price: "$12.49",
    image: "/lovable-uploads/2abc262b-2602-434c-9ab6-cbf39724a4b0.png",
    link: "https://murphyandmcneil.com/products/rockwell-double-edge-razor-blades?sca_ref=8468498.oO9QXbgAQO"
  }
];
